import axiosInstance from "../config/axios.config";

export const nutritionistInspectionAPI = (payload) => {
  return axiosInstance.post(`inpatient/nutrition-initial-assessment/`, payload);
};
export const updateNutritionistInspectionAPI = (id, payload) => {
  return axiosInstance.patch(
    `inpatient/nutrition-initial-assessment/${id}/`,
    payload
  );
};

export const getNutritionistInspectionAPI = (admisssionId) => {
  return axiosInstance.get(
    `inpatient/nutrition-initial-assessment/${admisssionId}/`
  );
};

export const nutritionistRiskAssessmentAPI = (payload) => {
  return axiosInstance.post(`inpatient/nutrition-risk-assessment/`, payload);
};
export const updateNutritionistRiskAssessmentAPI = (id, payload) => {
  return axiosInstance.patch(
    `inpatient/nutrition-risk-assessment/${id}/`,
    payload
  );
};

export const getNutritionistRiskAssessmentAPI = (admisssionId) => {
  return axiosInstance.get(
    `inpatient/nutrition-risk-assessment/${admisssionId}/`
  );
};

export const getLatestNutritionRiskAssessmentAPI = (admisssionId) => {
  return axiosInstance.get(
    `inpatient/latest-nutrition-risk-assessment/?admission_id=${admisssionId}`
  );
};
//dietitems
export const addPatientDietItemsApi = (id, payload) => {
  return axiosInstance.post(`inpatient/patient-dietitems/${id}/`, payload);
};
export const getPatientDietItemsApi = (id) => {
  return axiosInstance.get(`inpatient/patient-dietitems/${id}/`);
};
export const deleteDietItems = (id, diet_id) => {
  return axiosInstance.delete(`inpatient/patient-dietitems/${id}/${diet_id}/`);
};
export const updatePatientDietItemsApi = (id, payload) => {
  return axiosInstance.patch(
    `inpatient/patient-dietitems/update/${id}/`,
    payload
  );
};

export const getDietHistoryAPI = (admissionId, params = {}) => {
  return axiosInstance.get(`/inpatient/patient-diethistory/${admissionId}/`, {
    params,
  });
};
export const patchAdmissionTherapySummaryApi = (payload) =>
  axiosInstance.patch("/inpatient/admission-therapy-summary/", payload);
